import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const offersService = new Service('/products/offer', HALApiService, createItemsData)
